var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.999 136V80H83.585L248.621 238.688C253.34 243.219 255.996 249.469 255.996 256S253.34 268.781 248.621 273.312L83.585 432H335.999V376C335.999 362.75 346.749 352 359.999 352C373.25 352 384 362.75 384 376V456C384 469.25 373.25 480 359.999 480H23.99C14.208 480 5.395 474.062 1.739 464.969S0.302 445.5 7.364 438.687L197.37 256L7.364 73.312C0.301 66.5 -1.917 56.125 1.739 47.031S14.208 32 23.99 32H359.999C373.25 32 384 42.75 384 56V136C384 149.25 373.25 160 359.999 160C346.749 160 335.999 149.25 335.999 136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/sigma.f5f75023b7da1272feaf68e9ad389721.svg";
export { ForwardRef as ReactComponent };